var dt_template = {
  query: "",
  variables: {},
};
export const buildLoginRequest = (data) => {
  let login = {
    query:
      "mutation($email:String!, $password:String!){\n  login(\n    email: $email,\n    password:$password\n  ){\n    refreshToken\n    token\n  isUser\n  user{\n  location{address\n country\n latitude\n longitude\n} selectedAccount{entity{tier}} role{tier}  defaultColor\n lookupId\n      email\n      phone\n      lang\n      firstName\n      lastName\n      displayName\n      avatar\n      isActive\n                 }\n    account{\nrecommendedTextMsgBytes\n selectedIntegrationPartner{name\n} entity{\ntier\n}\n syncAccountDetailsWithPartner\n speedUnitStr\n speedUnit\n puapikeyAccount{apiKey\n name\n \n}  lookupId\n            name\n      logo\n      isActive\n          location{\n        address\n        postCode\n  longitude\n      country\n  latitude\n     }\n    }\n  }\n}",
    variables: data,
  };

  dt_template.query = login.query;
  dt_template.variables = login.variables;
  return dt_template;
};
export const buildCreateAccountRequest = (data) => {
  let login = {
    query:
      "mutation($user:NewUserInputType!) {\n  registerUserAccount(user:$user  ){\n    message,\n    refreshToken\n    token\n   user{\n  selectedAccount{entity{tier}}  role{tier}  defaultColor\n  lookupId\n      email\n      phone\n      lang\n      firstName\n      lastName\n      displayName\n      avatar\n      isActive\n      loginNextAttempt\n      loginNumFails\n      resetNextAttempt\n      pwUpdateToken\n      updatedAt\n      isDeleted\n      deletedAt\n      lastLogin\n    }\n    account{\nrecommendedTextMsgBytes\n selectedIntegrationPartner{name\n}\n syncAccountDetailsWithPartner  puapikeyAccount{apiKey\n name\n \n}  lookupId\n      owner{\n        lookupId\n      }\n      name\n      logo\n      isActive\n      users{\n        lookupId\n      }\n      location{\n        address\n        postCode\n        country\n      }\n    }\n  }\n}",
    variables: data,
  };

  dt_template.query = login.query;
  dt_template.variables = login.variables;
  return dt_template;
};
export const buildResetPwdRequest = (data) => {
  let resetPwd = {
    query:
      "mutation($email:String!){\n  requestResetPassword(email:$email){\n    message\n    user{\n      lookupId\n      pwUpdateToken\n    }\n  }\n}",
    variables: data,
  };

  dt_template.query = resetPwd.query;
  dt_template.variables = resetPwd.variables;
  return dt_template;
};
export const updatePassword = (data) => {
  let updatePwd = {
    query:
      "mutation($pwUpdateToken:String!, $password:String!){\n  updatePassword(pwUpdateToken:$pwUpdateToken,password:$password){\n    message\n    user{\n      lookupId\n    }\n    token\n  }\n}",
    variables: data,
  };
  dt_template.query = updatePwd.query;
  dt_template.variables = updatePwd.variables;
  return dt_template;
};
export const checkUserToken = (data) => {
  let userAuth = {
    query:
      "mutation RefreshToken($refreshToken: String!) {\n  refreshToken(refreshToken: $refreshToken) {\n    token\n    payload\n    refreshToken\n    refreshExpiresIn\n  }\n}",
    variables: data,
  };
  dt_template.query = userAuth.query;
  dt_template.variables = userAuth.variables;
  return dt_template;
};
export const checkUserAuth = () => {
  let userAuth = {
    query:
      "query{\n  userAuth{\n isUser\n    user{\n selectedAccount{entity{tier}} location{address\n country\n latitude\n longitude\n}  role{tier} defaultColor\n  lookupId\n      email\n      phone\n      lang\n      firstName\n      lastName\n      displayName\n      avatar\n      isActive\n         updatedAt\n      isDeleted\n        }\n    account{\n recommendedTextMsgBytes\n entity{tier}\n selectedIntegrationPartner{name}\n syncAccountDetailsWithPartner\n speedUnitStr\n speedUnit\n puapikeyAccount{apiKey\n name\n }    lookupId\n        name\n      logo\n      isActive\n           location{\n        address\n        postCode\n        country\n   longitude\n  latitude\n  }\n    }\n      }\n}",
    variables: {},
  };
  dt_template.query = userAuth.query;
  dt_template.variables = userAuth.variables;
  return dt_template;
};
export const createNewuser = (data) => {
  let createNewuser = {
    query:
      "mutation ($accountLookupId: String, $user: NewUserInputType!) {\n  createUser(accountLookupId: $accountLookupId, user: $user) {\n    message\n    pwUpdateToken\n    user {\n      firstName\n      lastName\n      email\n      phone\n      avatar\n      isActive\n    }\n  }\n}\n",
    variables: {
      accountLookupId: data.accountLookupId,
      user: data.user,
    },
  };
  dt_template.query = createNewuser.query;
  dt_template.variables = createNewuser.variables;
  return dt_template;
};

//VEhicles
export const getVehicles = (params) => {
  let vehicles = {
    query:
      "query($display:String,$lookupIds:[String], $search:String, $offset:Int, $limit:Int, $ascending:Boolean, $startDate:String, $endDate:String){\n  vehicles(display:$display,lookupIds:$lookupIds, search:$search, offset:$offset, limit:$limit, ascending:$ascending, startDate:$startDate, endDate:$endDate){\n    count\n    vehicles{\n fences {lookupId\n displayName:name} speedUnitStr\n   speedUnit\n  lookupId\n  alerts\n    name\n      make\n      model\n      year\n      vin\n   licensePlate{\n        number\n}    mileage\n avatar\n location{address\n country\n latitude\n longitude\n postCode\n}\n vClass{lookupId\n displayName\n} terminal{\n   externalId     lookupId\n        macAddress\n        deviceName\n      }\n     licensePlate{\n        number\n        expiration\n      }\n      ownerAccount{\n        lookupId\n        name\n      }\n      }\n  }\n}",
    variables: params,
  };
  dt_template.query = vehicles.query;
  dt_template.variables = vehicles.variables;
  return dt_template;
};
export const getGroups = (params) => {
  let vehicles = {
    query:
      "query($lookupIds:[String], $search:String, $offset:Int, $limit:Int, $ascending:Boolean, $startDate:String, $endDate:String){\n  groups(lookupIds:$lookupIds, search:$search, offset:$offset, limit:$limit, ascending:$ascending, startDate:$startDate, endDate:$endDate){\n    count\n    groups{\n      id\n      name\n       lookupId\n   \n     vehicles{\n    vin\n    name\n      }\n  location{\n address\n country\n   latitude\n longitude\n }\n    account{\n        name\n              }\n    }\n  }\n systemVersion { lookupId\n name\n description\n createdAt releasedAt}\n}\n",
    variables: params,
  };
  dt_template.query = vehicles.query;
  dt_template.variables = vehicles.variables;
  return dt_template;
};
export const getTerminalById = (params) => {
  let terminals = {
    query:
      "query($lookupId:String){ \n  terminal(lookupId:$lookupId){\n   apiKey  externalId\n   lookupId\n      deviceName\n      terminalType:terminalTypeStr\n      macAddress\n      updatedAt\n   createdAt\n      isActive\n      isOnline\n      description\n      destPort\n      destIp\n      recvPort\n   location{longitude\n latitude\n address\n country\n}  }\n}\n",
    variables: params,
  };
  dt_template.query = terminals.query;
  dt_template.variables = terminals.variables;
  return dt_template;
};
export const fetchTerminalDetails = (params) => {
  let terminals = {
    query:
      "query($apiKey:StrippedString!, $externalId:StrippedString!, $integrationPartnerLookupId:String){\n  manualTerminal(apiKey:$apiKey, externalId:$externalId, integrationPartnerLookupId:$integrationPartnerLookupId){\n    deviceName\n    macAddress\n    terminalType\n    externalId\n    hardware\n    firmware\n    latitude\n    longitude\n    locationName\n    destIp\n    destPort\n    recvPort\n    apiKey\n description  }\n}\n",
    variables: params,
  };
  dt_template.query = terminals.query;
  dt_template.variables = terminals.variables;
  return dt_template;
};
export const createTerminalManually = (params) => {
  let terminals = {
    query:
      "mutation($terminalData:TerminalInputType!, $integrationPartnerLookupId:String, $accountLookupId:String){\n  createManualTerminal(accountLookupId:$accountLookupId, terminalData:$terminalData, integrationPartnerLookupId:$integrationPartnerLookupId){\n    terminal{\n      lookupId\n      deviceName\n      externalId\n      isOnline\n   apiKey   creationType     user{\n        lookupId\n        firstName\n        lastName\n      }\n      location{\n        name\n        address\n        longitude\n        latitude\n      }\n      vehicleTerminal{\n        terminal{\n          lookupId\n          deviceName\n        }\n        lookupId\n        name\n        make\n        model\n        year\n        leadOperator{\n          lookupId\n          firstName\n          lastName\n          terminalUser{\n            lookupId\n            deviceName\n          }\n        }\n      }\n    }\n  }\n}\n",
    variables: params,
  };
  dt_template.query = terminals.query;
  dt_template.variables = terminals.variables;
  return dt_template;
};
export const editTerminalApikey = (params) => {
  let terminals = {
    query:
      "mutation($lookupId:String!, $apiKey:String!, $accountLookupId:String){\nupdateManualTerminalApiKey(lookupId:$lookupId, apiKey:$apiKey, accountLookupId:$accountLookupId){\nterminal{\nlookupId\napiKey\n}\n}\n}",
    variables: params,
  };
  dt_template.query = terminals.query;
  dt_template.variables = terminals.variables;
  return dt_template;
};
export const getTerminals = (params) => {
  let terminals = {
    query:
      "query($search:String, $offset:Int, $limit:Int, $ascending:Boolean, $startDate:String, $endDate:String, $lookupIds:[String]){ \n  terminals(search:$search, offset:$offset, limit:$limit, ascending:$ascending, startDate:$startDate, endDate:$endDate, lookupIds:$lookupIds){\n    count\n    terminals{account{name\n} externalOwnerAccountName\n lastSyncedAt\n syncStatus\n apiKey\n creationType externalId\n   lookupId\n      deviceName\n      terminalType\n      macAddress\n      updatedAt\n   createdAt\n      isActive\n      isOnline\n      description\n      destPort\n      destIp\n      recvPort\n   location{longitude\n latitude\n address\n country\n}     user{\n        lookupId\n        firstName\n        lastName\n      }\n      \n    }\n  }\n}\n",
    variables: params,
  };
  dt_template.query = terminals.query;
  dt_template.variables = terminals.variables;
  return dt_template;
};
export const getVehiclesTerminals = (params) => {
  let terminals = {
    query:
      "query($lookupIds:[String], $search:String, $offset:Int, $limit:Int, $ascending:Boolean, $startDate:String, $endDate:String){\n  vehicles(lookupIds:$lookupIds, search:$search, offset:$offset, limit:$limit, ascending:$ascending, startDate:$startDate, endDate:$endDate){\n    count\n    vehicles{\n  fences{lookupId\n displayName:name}    lookupId\n  alerts\n    name\n speedUnitStr\n  speedUnit\n    make\n      model\n      year\n      vin\n      mileage\n avatar\n location{address\n country\n latitude\n longitude\n postCode\n}\n vClass{lookupId\n displayName\n} terminal{\n lastSyncedAt\n syncStatus    externalId\n   lookupId\n        macAddress\n        deviceName\n   externalOwnerAccountName   }\n     licensePlate{\n        number\n        expiration\n      }\n      ownerAccount{\n        lookupId\n        name\n      }\n      }\n  } terminals(search:$search, offset:$offset, limit:$limit, ascending:$ascending, startDate:$startDate, endDate:$endDate, lookupIds:$lookupIds){\n    count\n    terminals{account{name\n} externalOwnerAccountName\n lastSyncedAt\n syncStatus\n apiKey   creationType externalId\n    lookupId\n      deviceName\n      terminalType\n      macAddress\n      updatedAt\n   createdAt\n      isActive\n      isOnline\n      description\n      destPort\n      destIp\n      recvPort\n   location{longitude\n latitude\n address\n country\n}    user{\n        lookupId\n        firstName\n        lastName\n      }\n      \n    }\n  }\n systemVersion{ lookupId\n name\n description\n createdAt releasedAt}\n \n }",
    variables: params,
  };
  dt_template.query = terminals.query;
  dt_template.variables = terminals.variables;
  return dt_template;
};

export const updateUser = (data) => {
  let updateUser = {
    query:
      "mutation ($lookupId: String!, $user: UpdateUserInputType!) {\n  updateUser(lookupId: $lookupId, user: $user) {\n    message\n    user {\n  role{tier} defaultColor\n   lookupId\n      email\n      firstName\n      lastName\n      phone\n      avatar\n      location {\n        address\n        country\n        postCode\n   latitude\n longitude\n   }\n    }\n  }\n}\n",
    variables: {
      lookupId: data.lookupId,
      user: data.user,
    },
  };
  dt_template.query = updateUser.query;
  dt_template.variables = updateUser.variables;
  return dt_template;
};
export const getAvailableTerminals = (data) => {
  let terminals = {
    query:
      "query ($display: String, $first: String, $accountLookupId:String) {\n  terminals(display: $display, first: $first, accountLookupId:$accountLookupId) {\n    terminals {\n   externalId\n   deviceName\n      terminalType\n      macAddress\n   lookupId\n }\n  }\n}\n",
    variables: {
      first: data.first,
      display: data.display,
      accountLookupId: data.accountLookupId,
    },
  };
  dt_template.query = terminals.query;
  dt_template.variables = terminals.variables;
  return dt_template;
};
export const getAvailableTerminalsAndFencing = (data) => {
  let terminals = {
    query:
      "query ($display: String, $first: String, $accountLookupId:String) {\n accountFencing{objs{lookupId\n displayName:name}} terminals(display: $display, first: $first, accountLookupId:$accountLookupId) {\n    terminals {\n   externalId\n   deviceName\n      terminalType\n      macAddress\n   lookupId\n }\n  }\n}\n",
    variables: {
      first: data.first,
      display: data.display,
      accountLookupId: data.accountLookupId,
    },
  };
  dt_template.query = terminals.query;
  dt_template.variables = terminals.variables;
  return dt_template;
};
export const updateAccount = (data) => {
  let updateAccount = {
    query:
      "mutation ($lookupId:String, $account: AccountInputType!) {\n  updateAccount(lookupId:$lookupId, account: $account ) {\n    message\n    account {\n   selectedIntegrationPartner{name\n}   lookupId\n      owner {\n        firstName\n        lastName\n        avatar\n        isActive\n      }\n      location {\n        country\n        address\n        latitude\n        longitude\n        country\n        lookupId\n      }\n    }\n  }\n}\n",
    variables: data,
  };
  dt_template.query = updateAccount.query;
  dt_template.variables = updateAccount.variables;
  return dt_template;
};
export const createVehicle = (data) => {
  let createVehicle = {
    query:
      "mutation ($vehicle: CreateVehicleType!) {\n  createVehicle(vehicle: $vehicle) {\n    message\n    vehicle {\n  lookupId    updatedAt\n      vin\n      model\n      avatar\n      name\n      year\n      licensePlate {\n        number\n        expiration\n      }\n      terminal {\n        lookupId\n        macAddress\n        deviceName\n      }\n      vClass {\n        lookupId\n        displayName\n        nameLower\n      }\n    }\n  }\n}\n",
    variables: {
      vehicle: data.vehicle,
    },
  };
  dt_template.query = createVehicle.query;
  dt_template.variables = createVehicle.variables;
  return dt_template;
};
export const assignFencesToVehicle = (data) => {
  let assignFencesToVehicle = {
    query:
    "mutation($vehicleLookupId:String!, $fencesLookupIds:[String], $accountLookupId:String){\n\tassignFencesToVehicle(vehicleLookupId:$vehicleLookupId, fencesLookupIds:$fencesLookupIds, accountLookupId:$accountLookupId){\n\t\tvehicle{\n\t\t\tname\n\t\t\tlookupId\n\t\t\tfences{\n\t\t\t\tlookupId\n\t\t\t\tname\n\t\t\t}\n\t\t}\n\t}\n}",
    variables: data,
  };
  dt_template.query = assignFencesToVehicle.query;
  dt_template.variables = assignFencesToVehicle.variables;
  return dt_template;
};
export const createGroup = (data) => {
  let creatGroup = {
    query:
      "mutation ($group: GroupInputType) {\n  createGroup(group: $group) {\n    message\n    group {\n      updatedAt\n      name\n      vehicles {\n        lookupId\n      }\n }\n  }\n}\n",
    variables: {
      group: data.group,
    },
  };
  dt_template.query = creatGroup.query;
  dt_template.variables = creatGroup.variables;
  return dt_template;
};
export const updateVehicle = (data) => {
  let updateVehicle = {
    query:
    "mutation($lookupId:String!, $terminalLookupId:String, $vehicle:UpdateVehicleType!, $fencesLookupIds:[String], $accountLookupId:String){\n  updateVehicle(lookupId:$lookupId, terminalLookupId:$terminalLookupId, vehicle:$vehicle) {\n    message\n    vehicle {\n  lookupId    updatedAt\n      vin\n      model\n      avatar\n      name\n      year\n   location{address\n country\n latitude\n longitude\n postCode\n}\n   licensePlate {\n        number\n        expiration\n      }\n      terminal {\n        lookupId\n        macAddress\n        deviceName\n      }\n      vClass {\n        lookupId\n        displayName\n        nameLower\n      }\n    }\n  }\n\t\tassignFencesToVehicle(vehicleLookupId:$lookupId, fencesLookupIds:$fencesLookupIds, accountLookupId:$accountLookupId){\n\t\tvehicle{\n\t\t\tname\n\t\t\tlookupId\n\t\t\tfences{\n\t\t\t\tlookupId\n\t\t\t\tname\n\t\t\t}\n\t\t}\n\t}\n\t\n}\n",
    variables: data,
  };
  dt_template.query = updateVehicle.query;
  dt_template.variables = updateVehicle.variables;
  return dt_template;
};
export const getIntegrationPartners = () => {
  let partnerQuery = {
    query:
      "query{ \n  integrationPartners{\n    partners{\n      lookupId      \n url\n name\n   }\n  }\n}\n\n",
    variables: {},
  };
  dt_template.query = partnerQuery.query;
  dt_template.variables = partnerQuery.variables;
  return dt_template;
};
export const integrationPartnersAndChatConfig = (data) => {
  let integrationPartnersAndChatConfig = {
    query:
      "query ($lookupId: String!) {\n\tintegrationPartners {\n\t\tpartners {\n\t\t\tlookupId\n\t\t\tname\n\n\t\t\turl\n\t\t\tapiUrl\n\t\t}\n\t}\n\taccountChatConfiguration(lookupId: $lookupId) {\n\t\trecommendedTextMsgBytes\n\t\tackMessageTimeout\n\t\ttransmitMaxRetries\n\t\tkeepalivePeriod\n\t\tkeepaliveTimeout\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = integrationPartnersAndChatConfig.query;
  dt_template.variables = integrationPartnersAndChatConfig.variables;
  return dt_template;
};
export const getGroupDue = (data) => {
  let getGroupDue = {
    query:
      "query ($lookup_id: String) {\n  vehicleDualReturn(lookupId: $lookup_id) {\n    \n    selected {\n      name\n      vin\n    licensePlate{\n        number\n}   lookupId\n      vClass{\n        displayName\n        lookupId\n      }\n    }\n    selectedCount\n    available {\n  licensePlate{\n number}\n    lookupId\n      name\n      vin\n      vClass{\n        displayName\n        lookupId\n        \n      }\n    }\n    availableCount\n  }\n}\n",
    variables: data,
  };
  dt_template.query = getGroupDue.query;
  dt_template.variables = getGroupDue.variables;
  return dt_template;
};
export const updateGroup = (data) => {
  let updateGroup = {
    query:
      "mutation ($group: GroupInputType,$lookupId: String) {\n  updateGroup(lookupId:$lookupId,group: $group) {\n    message\n    group {\n      name\n      location {\n        address\n        country\n        latitude\n        longitude\n      }\n      updatedAt\n      vehicles {\n        name\n      }\n    }\n  }\n}\n",
    variables: {
      group: data.group,
      lookupId: data.lookupId,
    },
  };
  dt_template.query = updateGroup.query;
  dt_template.variables = updateGroup.variables;
  return dt_template;
};
/** login as user */
export const loginAsUser = (params) => {
  let loginAsUser = {
    query:
    "mutation($lookupId:String!){\n  loginAsUser(\n    lookupId: $lookupId ){\n    refreshToken\n    token\n  isUser\n  user{\n  location{address\n country\n latitude\n longitude\n} role{tier}  defaultColor\n lookupId\n      email\n      phone\n      lang\n      firstName\n      lastName\n      displayName\n      avatar\n      isActive\n                 }\n    account{\nrecommendedTextMsgBytes\n selectedIntegrationPartner{name\n} entity{\ntier\n}\n syncAccountDetailsWithPartner\n speedUnitStr\n speedUnit\n puapikeyAccount{apiKey\n name\n \n}  lookupId\n            name\n      logo\n      isActive\n          location{\n        address\n        postCode\n  longitude\n      country\n  latitude\n     }\n    }\n  }\n}",
    variables: params,
  };
  dt_template.query = loginAsUser.query;
  dt_template.variables = loginAsUser.variables;
  return dt_template;
};
/**
 * delete records
 */
export const deleteUser = (params) => {
  let partnerQuery = {
    query:
      "mutation($lookupId:String!){\n  deleteUser(lookupId:$lookupId){\n    message\n  }\n}",
    variables: params,
  };
  dt_template.query = partnerQuery.query;
  dt_template.variables = partnerQuery.variables;
  return dt_template;
};
export const deleteVehicle = (params) => {
  let partnerQuery = {
    query:
      "mutation($lookupId:String!){\n  deleteVehicle(lookupId:$lookupId){\n    message\n  }\n}",
    variables: params,
  };
  dt_template.query = partnerQuery.query;
  dt_template.variables = partnerQuery.variables;
  return dt_template;
};
export const deleteGroup = (params) => {
  let partnerQuery = {
    query:
      "mutation($lookupId:String!){\n  deleteGroup(lookupId:$lookupId){\n    message\n  }\n}",
    variables: params,
  };
  dt_template.query = partnerQuery.query;
  dt_template.variables = partnerQuery.variables;
  return dt_template;
};
/**
 * Sync terminals
 */
export const getExternalTerminals = (params) => {
  let externalTermQuery = {
    query:
      "query($partnerLookupId:String!, $accountLookupId:String, $includeManualElsewhere: Boolean){ \n  externalTerminals(partnerLookupId:$partnerLookupId, accountLookupId:$accountLookupId, includeManualElsewhere:$includeManualElsewhere){\n    externalTerminals{\n  manuallyAddedElsewhere\n manuallyAddedElsewhereAccount\n    externalId\n      deviceName\n           terminalType\n      description\n      hardware\n      firmware\n      latitude\n      longitude\n locationName\n      isOnline\n    }\n    externalCount\n    onetrackTerminals{\n      lookupId\n      externalId\n      deviceName\n      macAddress\n      description\n      terminalType\n      hardware\n      firmware\n      location{longitude\n latitude\n address\n }  isOnline\n    }\n    onetrackCount\n  }\n}\n",
    variables: params,
  };
  dt_template.query = externalTermQuery.query;
  dt_template.variables = externalTermQuery.variables;
  return dt_template;
};

export const syncTerminals = (params) => {
  let sync = {
    query:
      "mutation($accountLookupId:String, $partnerLookupId:String!, $addTerminals:[TerminalInputType], $removeTerminalsLookupIds:[String]){\n  syncNmsTerminals(accountLookupId:$accountLookupId, partnerLookupId:$partnerLookupId, addTerminals:$addTerminals, removeTerminalsLookupIds:$removeTerminalsLookupIds){\n    addedTerminals{\n      lookupId\n      externalId\n      deviceName\n      macAddress\n      description\n      terminalType\n      hardware\n      firmware\n           isOnline\n    }\n    count\n    removedCount\n   \n  }\n}\n",
    variables: params,
  };
  dt_template.query = sync.query;
  dt_template.variables = sync.variables;
  return dt_template;
};

export const activateTerminal = (data) => {
  let activateTerminal = {
    query:
      "mutation ($lookupId: String!) {\n  activateTerminal(lookupId: $lookupId) {\n    message\n  }\n}\n",
    variables: {
      lookupId: data.lookupId,
    },
  };
  dt_template.query = activateTerminal.query;
  dt_template.variables = activateTerminal.variables;
  return dt_template;
};
export const deactivateTerminal = (data) => {
  let deactivateTerminal = {
    query:
      "mutation ($lookupId: String!) {\n  deactivateTerminal(lookupId: $lookupId) {\n    message\n  }\n}\n",
    variables: {
      lookupId: data.lookupId,
    },
  };
  dt_template.query = deactivateTerminal.query;
  dt_template.variables = deactivateTerminal.variables;
  return dt_template;
};
export const deleteTerminal = (data) => {
  let activateTerminal = {
    query:
      "mutation ($terminalLookupId:String!, $accountLookupId:String) {\n  deleteTerminal(terminalLookupId:$terminalLookupId, accountLookupId:$accountLookupId) {\n    message\n  }\n}\n",
    variables: data,
  };
  dt_template.query = activateTerminal.query;
  dt_template.variables = activateTerminal.variables;
  return dt_template;
};
//dashboard queries
export const getGroupsAndVehicles = (data) => {
  let list = {
    query:
      "query ($lookupIds: [String], $search: String, $offset: Int, $limit: Int, $ascending: Boolean, $startDate: String, $endDate: String, $exclude: [String]) {\n  groups(lookupIds: $lookupIds, search: $search, offset: $offset, limit: $limit, ascending: $ascending, startDate: $startDate, endDate: $endDate, exclude: $exclude) {\n    count\n    groups {\n      lookupId\n      name      \n       vehicles {\n    vClass{nameLower \n lookupId\n}    lookupId\n        name\n vin   location{\n          latitude\n          longitude\n         }\n     lastTelemetry{\n          latitude\n          longitude\n         }\n      }      \n    }\n  }\n}\n\n",
    variables: data,
  };
  dt_template.query = list.query;
  dt_template.variables = list.variables;
  return dt_template;
};
export const getVehiclesForMap = (data) => {
  let list = {
    query:
      "query($exclude: [String], $include: [String], $search: String){\n  vehicleMapV2(exclude: $exclude, include: $include, search: $search){objs{showVehicleOutsideFenceAnimation\nlastValidHeading{  heading } \navatar\nsosAlert{\nlookupId\nalertVehiclealertupdatemessage{status\n lookupId\n}\n }\n newMessageAlert{\nisActive\n}\nexitFenceAlert{\n read\n }\nvehicleIsOutsideFence\nheadingAdjustment\n speedUnit\n speedUnitStr\n   lookupId\n  name\n  vin\n  make\n model\n year\n licensePlate{\n number\n}\nsosAlert{\nisActive\n}\n      vClass{\n   usesRoads\n       nameLower\n          displayName\n          lookupId\n        }\n        location{\n          latitude\n          longitude\n   address  country   }\n  lastValidPosition{\nlatitude\n          longitude\n}\n      terminal{lookupId\n externalId\n isOnline\nisAlive\n} groupCount\n relatedGroups{\n      lookupId\n      name\n    }\n  }\nsosCount\n onlineCount\n offlineCount\n aliveCount\n deadCount\n}\n   groups {\n    groups {\n      lookupId\n      name \n  vehicles{lookupId}  }\n    }\n systemVersion{ lookupId\n name\n description\n createdAt releasedAt}\n\n \n}",
    variables: data,
  };
  dt_template.query = list.query;
  dt_template.variables = list.variables;
  return dt_template;
};
export const getVehiclesForMapAndAccountFencing = (data) => {
  let list = {
    query:
      "query($exclude: [String], $include: [String], $search: String){\n accountFencing {objs{\n\t\tisActive \n lookupId\n\t\tcreatedAt\n\t\tupdatedAt\n\t\tname\n\t\tuuid\n\t\tcolor\n\t\tborderColor\n\t\tdrawn\n\t\tline\n\t\tcircle\n\t\trectangle\n\t\n\t type\n} count}\n vehicleMapV2(exclude: $exclude, include: $include, search: $search){objs{showVehicleOutsideFenceAnimation\n avatar\nsosAlert{\nlookupId\nalertVehiclealertupdatemessage{status\nlookupId\n}\n}\nnewMessageAlert{\nisActive}\n vehicleIsOutsideFence\nexitFenceAlert{\n read\n}\n lastValidHeading{  heading } \n headingAdjustment\n speedUnit\n speedUnitStr\n   lookupId\n  name\n  vin\n  make\n model\n year\n licensePlate{\n        number\n      }      vClass{\n   usesRoads\n       nameLower\n          displayName\n          lookupId\n        }\n        location{\n          latitude\n          longitude\n   address  country   }\n    lastValidPosition{\nlatitude\n          longitude\n}\n        terminal{lookupId\n externalId\n isOnline\nisAlive\n} groupCount\n relatedGroups{\n      lookupId\n      name\n    }\n  }\n onlineCount\n offlineCount\n aliveCount\n deadCount\nsosCount\n}\n     groups {\n    groups {\n      lookupId\n      name \n  vehicles{lookupId}  }\n    }\n systemVersion{ lookupId\n name\n description\n createdAt releasedAt}\n \n \n}",
    variables: data,
  };
  dt_template.query = list.query;
  dt_template.variables = list.variables;
  return dt_template;
};
export const socket = (data) => {
  let socket = {
    query:
      "subscription ($lookupId:String) {\n  onNewTelemetry(lookupId:$lookupId) {\n    polytrail {\n      longitude\n      latitude\n    }\n    telemetry {\n      longitude\n      latitude\n      latitude\n      longitude\n      inclination\n      heading\n      maxAcceleration\n      createdAt\n      speed\n    }\n    vehicle {\n      name\n      vin\n      lookupId\n      updatedAt\n      make\n      licensePlate{\n        number\n      }\n      \n      location {\n        latitude\n        longitude\n        country\n        address\n      }\n      vClass {\n        displayName\n        lookupId\n      }\n    }\n  }\n}",
    variables: {
      lookupId: data.lookupId,
    },
  };
  dt_template.query = socket.query;
  dt_template.variables = socket.variables;
  return dt_template;
};
export const getTelemetryHistory = (data) => {
  let list = {
    query:
      "query ($offset:Int, $limit:Int,$vehicleLookupId: String,$startDate:String,$endDate:String,$points:Int) {\n  telemetryHistory(offset:$offset, limit:$limit,vehicleLookupId: $vehicleLookupId ,startDate:$startDate,endDate:$endDate,points:$points) {\n    telemetry {\n      longitude\n      latitude\n      latitude\n      longitude\n      inclination\n      heading\n  createdAt\n      speed\n  gpsFixStatus\n inclinationSide\n  antennaTrackingStatus\n    }\n    count\n  }\n}",
    variables: data,
  };
  dt_template.query = list.query;
  dt_template.variables = list.variables;
  return dt_template;
};
export const getTelemetryHistoryCSV = (data) => {
  let list = {
    query:
      "mutation($goodTelemetry:Int,$categoryA:String,$lookupId:String,$excludeTypes:[Int],$localTz:String,$excludeGpsUnlock:Boolean,$modelName:String!,$search:String, $format:String!, $startDate:String, $endDate:String, $vehicleLookupId:String,$limit:Int,$maxRowsPerFile:Int,$points:Int,$alertType:VehicleAlertChoices){\n  exportTableFile(goodTelemetry:$goodTelemetry,categoryA:$categoryA,lookupId:$lookupId,excludeTypes:$excludeTypes,localTz:$localTz,alertType:$alertType,excludeGpsUnlock:$excludeGpsUnlock,modelName:$modelName, search:$search, format:$format, startDate:$startDate, endDate:$endDate, vehicleLookupId:$vehicleLookupId, limit:$limit,maxRowsPerFile:$maxRowsPerFile, points:$points){message\n    fileUrl\n  }\n}",
    variables: data,
  };
  dt_template.query = list.query;
  dt_template.variables = list.variables;
  return dt_template;
};
export const exportTelemetryPoints = (data) => {
  let list = {
    query: "",
    variables: data,
  };
  dt_template.query = list.query;
  dt_template.variables = list.variables;
  return dt_template;
};
export const globalSearch = (data) => {
  let globalSearch = {
    query:
      "query ($search: String, $offset: Int, $limit: Int) {\n  globalSearch(search: $search, offset: $offset, limit: $limit) {\n    vehicles {\n      lookupId\n      vin\n      leadOperator {\n        firstName\n        lastName\n      }\n      terminal {\n        terminalType\n        externalId\n        isOnline\n      }\n      licensePlate {\n        number\n      }\n    }\n    count\n  }\n}\n",
    variables: data,
  };
  dt_template.query = globalSearch.query;
  dt_template.variables = globalSearch.variables;
  return dt_template;
};
export const getWsAuthToken = () => {
  let authQuery = {
    query: "query{\n  generateWsToken\n}",
    variables: {},
  };
  dt_template.query = authQuery.query;
  dt_template.variables = authQuery.variables;
  return dt_template;
};
export const getWsAuthTokenAndAccountFencing = () => {
  let authQuery = {
    query:
      "query{\n  generateWsToken\n accountFencing {objs{\n\t\tlookupId\n\t\tcreatedAt\n\t\tupdatedAt\n\t\tname\n\t\tuuid\n\t\tcolor\n\t\tborderColor\n\t\tdrawn\n\t\tline\n\t\tcircle\n\t\trectangle\n\t\n\t type\n} count}}",
    variables: {},
  };
  dt_template.query = authQuery.query;
  dt_template.variables = authQuery.variables;
  return dt_template;
};
export const lastTelemetryHistory = (data) => {
  let lastTelemetryHistory = {
    query:
      "query ($lookup_id: String) {\n  lastTelemetryHistory(lookupId: $lookup_id) {\n    longitude\n    latitude\n    inclination\n    heading\n    gpsFixStatus\n    inclination\n    inclinationSide\n    maxAcceleration\n    createdAt\n    speed\n  }\n}\n",
    variables: data,
  };
  dt_template.query = lastTelemetryHistory.query;
  dt_template.variables = lastTelemetryHistory.variables;
  return dt_template;
};
export const deleteAccountObjects = (data) => {
  let delQuery = {
    query:
      "mutation($externalId:String,$deletedTelemetryId:Int,$vehicles:Boolean, $telemetryAndPolytrails:Boolean, $users:Boolean,$telemetryErrors:Boolean){\ndeleteAccountObjects(externalId:$externalId,deletedTelemetryId:$deletedTelemetryId,vehicles:$vehicles, telemetryAndPolytrails:$telemetryAndPolytrails, users:$users,telemetryErrors:$telemetryErrors){\nmessage\n}\n}",
    variables: data,
  };
  dt_template.query = delQuery.query;
  dt_template.variables = delQuery.variables;
  return dt_template;
};
export const authenticateUserForClearHistory = (data) => {
  let authQuery = {
    query:
      "query($password:String){ \n  verifyTopPassword(password:$password)\n}",
    variables: data,
  };
  dt_template.query = authQuery.query;
  dt_template.variables = authQuery.variables;
  return dt_template;
};
export const adjustVehicleHeading = (data) => {
  let adjustmutation = {
    query:
      "mutation($vehicleLookupId:String!, $headingAdjustment:Int!){\n  adjustVehicleHeading(vehicleLookupId:$vehicleLookupId, headingAdjustment: $headingAdjustment){\n    vehicle{\n      lookupId\n      headingAdjustment\n    }\n  }\n}",
    variables: data,
  };
  dt_template.query = adjustmutation.query;
  dt_template.variables = adjustmutation.variables;
  return dt_template;
};
export const createFencing = (data) => {
  let createFencing = {
    query:
      "mutation($fields: FencingInputType){\n\tcreateFencing(fields: $fields){\n\t\tmessage\n\t\tfencing{\n\t\t\ttype\n lookupId\n\t\t\tcreatedAt\n\t\t\tupdatedAt\n\t\t\tname\n\t\t\tuuid\n\t\t\tcolor\n\t\t\tborderColor\n\t\t\tdrawn\n\t\t\tline\n\t\t}\n\t}\n}",
    variables: data,
  };
  dt_template.query = createFencing.query;
  dt_template.variables = createFencing.variables;
  return dt_template;
};
export const getAccountFencing = (data) => {
  let getAccountFencing = {
    query:
      "query {\n\taccountFencing {objs{\n\t\tlookupId\n\t\tcreatedAt\n\t\tupdatedAt\n\t\tname\n\t\tuuid\n\t\tcolor\n\t\tborderColor\n\t\tdrawn\n\t\tline\n\t\tcircle\n\t\trectangle\n\t\n\t type\n}}\n}\n",
    variables: data,
  };
  dt_template.query = getAccountFencing.query;
  dt_template.variables = getAccountFencing.variables;
  return dt_template;
};
export const getVehiclesOnFencing = (data) => {
  let getAccountFencing = {
    query:
      "query($lookupId:String!){\n    fence(lookupId:$lookupId){\n        lookupId\n        name\n        vehicles{\n   terminal{lookupId}         lookupId\n            name\n\t\t\t\t\t  licensePlate{\n\t\t\t\t\t\t\tnumber\n\t\t\t\t\t\t}\n\t\t\t\t\tvClass{\n\t\t\t\t\t\tlookupId\n\t\t\t\t\t}\n\t\t\t\t\talerts\n        }\n    }\n}",
    variables: data,
  };
  dt_template.query = getAccountFencing.query;
  dt_template.variables = getAccountFencing.variables;
  return dt_template;
};
export const updateFencing = (data) => {
  let updateFencing = {
    query:
      "mutation($lookupId: String, $fields: FencingInputType){\n\tupdateFencing(lookupId: $lookupId, fields: $fields){\n\t\tmessage\n\t\tfencing{\n\t\t\ttype\nlookupId\n\t\t\tcreatedAt\n\t\t\tupdatedAt\n\t\t\tname\n\t\t\tuuid\n\t\t\tcolor\n\t\t\tborderColor\n\t\t\tdrawn\n\t\t\tline\ncircle\nrectangle\n\t\t}\n\t}\n}",
    variables: data,
  };
  dt_template.query = updateFencing.query;
  dt_template.variables = updateFencing.variables;
  return dt_template;
};
export const deleteFencing = (data) => {
  let deleteFencing = {
    query:
      "mutation($lookupId: String){\n\tdeleteFencing(lookupId: $lookupId){\n\t\tmessage\n\t}\n}",
    variables: data,
  };
  dt_template.query = deleteFencing.query;
  dt_template.variables = deleteFencing.variables;
  return dt_template;
};
export const toggleFenceActivation = (data) => {
  let deleteFencing = {
    query:
    "mutation($fenceLookupId:String!, $activationStatus:Boolean!, $accountLookupId:String){\n    toggleFenceActivation(fenceLookupId:$fenceLookupId, activationStatus:$activationStatus, accountLookupId:$accountLookupId){\n        fence{\n            lookupId\n            isActive\n        }\n    }\n}",
    variables: data,
  };
  dt_template.query = deleteFencing.query;
  dt_template.variables = deleteFencing.variables;
  return dt_template;
};
export const importFencing = (data) => {
  let importFencing = {
    query:"mutation($lookupIds:[String]){\n    exportKmlFile(lookupIds:$lookupIds){\n        fileUrl\n    }}",
    variables: data,
  };
  dt_template.query = importFencing.query;
  dt_template.variables = importFencing.variables;
  return dt_template;
};
export const overLayPolygons = (data) => {
  let importFencing = {
    query:"query($longitude:String!, $latitude:String!, $accountLookupId:String){\n    coordinateClickedDashboard(longitude:$longitude, latitude:$latitude, accountLookupId:$accountLookupId){count\n objs{uuid\n lookupId\n name\n}    }}",
    variables: data,
  };
  dt_template.query = importFencing.query;
  dt_template.variables = importFencing.variables;
  return dt_template;
};
export const chatMessages = (data) => {
  let chatMessages = {
    query:
      "query (\n\t$vehicleLookupId: StrippedString!\n\t$offset: Int\n\t$limit: Int\n\t$reverseAfterLimit: Boolean\n) {\n\tchatMessages(\n\t\tvehicleLookupId: $vehicleLookupId\n\t\toffset: $offset\n\t\tlimit: $limit\n\t\treverseAfterLimit: $reverseAfterLimit\n\t) {\n\t\tcount\n\t\tobjects {\n\t\t\tlookupId\n\t\t\tbody\n\t\t\tdirection\n\t\t\tstatus\n\t\t\tcreatedAt\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = chatMessages.query;
  dt_template.variables = chatMessages.variables;
  return dt_template;
};
export const hasfencing = (data) => {
  let hasFencing = {
    query: "\nquery{ hasFencing }\n\n",
    variables: data,
  };
  dt_template.query = hasFencing.query;
  dt_template.variables = hasFencing.variables;
  return dt_template;
};
export const sendVehicleAlertUpdate = (data) => {
  let sendVehicleAlertUpdate = {
    query:
      "mutation ($alertLookupId: String!) {\n\tsendVehicleAlertUpdate(alertLookupId: $alertLookupId) {\n\t\talert {\n\t\t\tlookupId\n\t\t\tcreatedAt\n\t\t\treceivedAt\n\t\t\tseenAt\n\t\t\tfailedAt\n\t\t\tstatus\n\t\t\talertVehiclealertupdatemessage {\n\t\t\t\tlookupId\n\t\t\t\tstatus\n\t\t\t}\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = sendVehicleAlertUpdate.query;
  dt_template.variables = sendVehicleAlertUpdate.variables;
  return dt_template;
};
export const markVehicleAlertRead = (data) => {
  let markVehicleAlertRead = {
    query:
      "mutation ($alertLookupId: String!) {\n\tmarkVehicleAlertRead(alertLookupId: $alertLookupId) {\n\t\talert {\n\t\t\tread\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = markVehicleAlertRead.query;
  dt_template.variables = markVehicleAlertRead.variables;
  return dt_template;
};
export const updateAccountChatConfig = (data) => {
  let updateAccountChatConfig = {
    query:
      "mutation (\n\t$lookupId: String!\n\t$chatConfiguration: AccountChatConfigurationInputType\n) {\n\tsetAccountChatConfiguration(\n\t\tlookupId: $lookupId\n\t\tchatConfiguration: $chatConfiguration\n\t) {\n\t\tchatConfiguration {\n\t\t\trecommendedTextMsgBytes\n\t\t\tackMessageTimeout\n\t\t\ttransmitMaxRetries\n\t\t\tkeepalivePeriod\n\t\t\tkeepaliveTimeout\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = updateAccountChatConfig.query;
  dt_template.variables = updateAccountChatConfig.variables;
  return dt_template;
};
export const hasFenceCreateWsToken = (data) => {
  let hasFenceCreateWsToken = {
    query:
      "query ($excludeRead: Boolean,$offset:Int, $limit:Int) {\n\t systemVersions(offset:$offset, limit:$limit){count\nobjs{lookupId\nname\ndescription\nreleasedAt\ncreatedAt\n}\n}\nuserNotifications(excludeRead: $excludeRead) {\n\t\tunreadNotificationsCount\nfenceUnreadNotificationsCount\nchatUnreadNotificationsCount\n	sosUnreadNotificationsCount\n\t}\n\thasFencing\n\tgenerateWsToken\n\tgenerateWsTokenbroadcast: generateWsToken\n}\n",
    variables: data,
  };
  dt_template.query = hasFenceCreateWsToken.query;
  dt_template.variables = hasFenceCreateWsToken.variables;
  return dt_template;
};
export const userNotifications = (data) => {
  let userNotifications = {
    "query": "query ($limit: Int, $offset: Int, $excludeRead: Boolean,$notificationType:UserNotificationChoices) {\n\tuserNotifications(notificationType:$notificationType,limit: $limit, offset: $offset, excludeRead: $excludeRead) {\n\t\tnotificationsCount\n\t\tunreadNotificationsCount\n\t\tsosNotificationsCount\n\t\tsosUnreadNotificationsCount\n\t\tfenceNotificationsCount\n\t\tfenceUnreadNotificationsCount\n\t\tchatNotificationsCount\n\t\tchatUnreadNotificationsCount\n\n\t\tsosNotifications {\n\t\t\tlookupId\n\t\t\tnotificationType\n\t\t\tgpsFixStatus\n\t\t\tlatitude\n\t\t\tlongitude\n\t\t\tcreatedAt\n\t\t\tread\n\t\t\treadDate\n\t\t\tdescription\n\t\t\tunreadNotificationsOfSameTypeAndVehicleForUser\n\t\t\tvehicle {\n\t\t\t\tlookupId\nlastValidHeading {\n\t\t\t\t\tlongitude\n\t\t\t\t\tlatitude\n\t\t\t\t}\n\t\t\t\tlastValidPosition {\n\t\t\t\t\tlatitude\n\t\t\t\t\tlongitude\n\t\t\t\t}\n\t\t\t\tlicensePlate {\n\t\t\t\t\tnumber\n\t\t\t\t}\n\t\t\t\tterminal {\n\t\t\t\t\tlookupId\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tfenceNotifications {\n\t\t\tlookupId\n\t\t\tnotificationType\n\t\t\tgpsFixStatus\n\t\t\tlatitude\n\t\t\tlongitude\n\t\t\tcreatedAt\n\t\t\tread\n\t\t\treadDate\n\t\t\tdescription\n\t\t\tunreadNotificationsOfSameTypeAndVehicleForUser\n\t\t\tvehicle {\n\t\t\t\tlookupId\nlastValidPosition {\n\t\t\t\t\tlatitude\n\t\t\t\t\tlongitude\n\t\t\t\t}\n\t\t\t\tlastValidHeading {\n\t\t\t\t\tlongitude\n\t\t\t\t\tlatitude\n\t\t\t\t}\n\t\t\t\tlicensePlate {\n\t\t\t\t\tnumber\n\t\t\t\t}\n\t\t\t\tterminal {\n\t\t\t\t\tlookupId\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tchatNotifications {\n\t\t\tlookupId\n\t\t\tnotificationType\n\t\t\tgpsFixStatus\n\t\t\tlatitude\n\t\t\tlongitude\n\t\t\tcreatedAt\n\t\t\tread\n\t\t\treadDate\n\t\t\tdescription\n\t\t\tunreadNotificationsOfSameTypeAndVehicleForUser\n\t\t\tvehicle {\n\t\t\t\tlookupId\nlastValidHeading {\n\t\t\t\t\tlongitude\n\t\t\t\t\tlatitude\n\t\t\t\t}\n\t\t\t\tlastValidPosition {\n\t\t\t\t\tlatitude\n\t\t\t\t\tlongitude\n\t\t\t\t}\n\t\t\t\tlicensePlate {\n\t\t\t\t\tnumber\n\t\t\t\t}\n\t\t\t\tterminal {\n\t\t\t\t\tlookupId\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = userNotifications.query;
  dt_template.variables = userNotifications.variables;
  return dt_template;
};
export const markVehicleAsRead = (data) => {
  let markVehicleAsRead = {
    query:
      "mutation ($notificationLookupIds: [String]) {\n\tmarkNotificationsRead(notificationLookupIds: $notificationLookupIds) {\n\t\tnotifications {\n\t\t\tlookupId\n\t\t\tread\n\t\t\treadDate\n\t\t\tuser {\n\t\t\t\tlookupId\n\t\t\t\tfirstName\n\t\t\t\tlastName\n\t\t\t\temail\n\t\t\t}\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = markVehicleAsRead.query;
  dt_template.variables = markVehicleAsRead.variables;
  return dt_template;
};
export const createBroadcastMessage = (data) => {
  let createBroadcastMessage = {
    query:
      "mutation ($body: StrippedString!) {\n\tcreateBroadcastMessage(body: $body) {\n\t\tbroadcast {\n\t\t\tlookupId\n\t\t\tcreatedAt\n\t\t\treceivedAt\n\t\t\tseenAt\n\t\t\tbody\n\t\t\tstatus\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = createBroadcastMessage.query;
  dt_template.variables = createBroadcastMessage.variables;
  return dt_template;
};
export const broadcastMessages = (data) => {
  let broadcastMessages = {
    query:
      "query ($limit: Int, $offset: Int, $reverseAfterLimit: Boolean) {\n\tbroadcastMessages(\n\t\tlimit: $limit\n\t\toffset: $offset\n\t\treverseAfterLimit: $reverseAfterLimit\n\t) {\n\t\tcount\n\t\tobjs {\n\t\t\tlookupId\n\t\t\tcreatedAt\n\t\t\tbody\n\t\t\tstatus\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = broadcastMessages.query;
  dt_template.variables = broadcastMessages.variables;
  return dt_template;
};
export const resendExpiredChatMessage = (data) => {
  let resendExpiredChatMessage = {
    query:
      "mutation ($messageLookupId: String!) {\n\tresendExpiredChatMessage(messageLookupId: $messageLookupId) {\n\t\tchatMessage {\n\t\t\tlookupId\n\t\t\tstatus\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = resendExpiredChatMessage.query;
  dt_template.variables = resendExpiredChatMessage.variables;
  return dt_template;
};
export const alertLogs = (data) => {
  let alertLogs = {
    query:
      "query (\n\t$lookupId: StrippedString!\n\t$alertType: VehicleAlertChoices\n\t$limit: Int\n\t$offset: Int\n\t$endDate: String\n\t$startDate: String\n) {\n\tvehicleAlerts(\n\t\tlookupId: $lookupId\n\t\talertType: $alertType\n\t\tlimit: $limit\n\t\toffset: $offset\n\t\tstartDate: $startDate\n\t\tendDate: $endDate\n\t) {\n\t\tcount\n\t\tobjects {\n\t\t\tlookupId\n\t\t\tcreatedAt\n\t\t\tread\n\t\t\treadAt\n\t\t\teventConcludedAt\n\t\t\tvehicleAlertsDisabledAt\n\t\t\tvehicleAlertsDisabled\n\t\t\tlatitude\n\t\t\tlongitude\n\t\t\tgpsFixStatus\n\t\t\treceivedAt\n\t\t\tseenAt\n\t\t\tfailedAt\n\t\t\tdismissedAt\nhelpBypassedAt\nhelpDispatchedAt\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = alertLogs.query;
  dt_template.variables = alertLogs.variables;
  return dt_template;
};
export const chatMsgLogs = (data) => {
  let chatMsgLogs = {
    query:
      "query (\n\t$vehicleLookupId: StrippedString!\n\t$offset: Int\n\t$limit: Int\n\t$startDate: String\n\t$reverseAfterLimit: Boolean\n\t$endDate: String\n,$excludeTypes: [Int]) {\n\tchatMessages(\n\t\tvehicleLookupId: $vehicleLookupId\n\t\toffset: $offset\n\t\tlimit: $limit\n\t\tstartDate: $startDate\n\t\tendDate: $endDate\n\t\treverseAfterLimit: $reverseAfterLimit\n\t,excludeTypes:$excludeTypes) {\n\t\tcount\n\t\tobjects {\n\t\t\tlookupId\n\t\t\tbody\n\t\t\tdirection\n\t\t\tstatus\n\t\t\tcreatedAt\ntotalSendCycles\ntotalRetriesOverAllCycles\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = chatMsgLogs.query;
  dt_template.variables = chatMsgLogs.variables;
  return dt_template;
};
export const vehiclePresubscription = (data) => {
  let vehiclePresubscription = {
    query:
      "query (\n\t$lookupId: String!\n\t$delta: Int\n\t$deltaType: Int\n\t$limitRecords: Int\n\t$startAt: String\n\t$display: String\n) {\n\tvehiclePresubscription(\n\t\tlookupId: $lookupId\n\t\tdelta: $delta\n\t\tdeltaType: $deltaType\n\t\tlimitRecords: $limitRecords\n\t\tstartAt: $startAt\n\t\tdisplay: $display\n\t) {\n\t\tlastValidHeading {\n\t\t\theading\n\t\t}\n\t\tlastValidPosition {\n\t\t\tlatitude\n\t\t\tlongitude\n\t\t}\n\t\tpolytrail {\n\t\t\tlongitude\n\t\t\tlatitude\n\t\t\tcreatedAt\n\t\t\ttransparent\n\t\t}\n\t\ttelemetry {\n\t\t\tlongitude\n\t\t\tlatitude\n\t\t\tinclination\n\t\t\theading\n\t\t\tcreatedAt\n\t\t\tspeed\n\t\t\tgpsFixStatus\n\t\t\tinclinationSide\n\t\t}\n\t\tvehicle {\n\t\t\tlookupId\n\t\t\tlocation {\n\t\t\t\tlatitude\n\t\t\t\tlongitude\n\t\t\t\taddress\n\t\t\t\tcountry\n\t\t\t}\n\t\t\tvClass {\n\t\t\t\tdisplayName\n\t\t\t\tlookupId\n\t\t\t\tnameLower\n\t\t\t\tusesRoads\n\t\t\t}\n\t\t\tname\n\t\t\tvin\n\t\t\tavatar\n\t\t\tmodel\n\t\t\tvin\n\t\t\tmake\n\t\t\tyear\n\t\t\tshowVehicleOutsideFenceAnimation\n\t\t\tvehicleIsOutsideFence\n\t\t\theadingAdjustment\n\t\t\tlicensePlate {\n\t\t\t\tnumber\n\t\t\t}\n\t\t\tspeedUnitStr\n\t\t\tspeedUnit\n\t\t\texitFenceAlert {\n\t\t\t\tlookupId\n\t\t\t\tread\n\t\t\t}\n\t\t\tnewMessageAlert {\n\t\t\t\tlookupId\n\t\t\t}\n\t\t\tsosAlert {\n\t\t\t\tlookupId\nalertVehiclealertupdatemessage{\nstatus\n}\t\t\t }\n\t\t\tterminal {\n\t\t\t\tisOnline\n\t\t\t\texternalId\n\t\t\t\tlookupId\n\t\t\t\tisAlive\n\t\t\t}\n\t\t}\n\t}\n\tfencesForVehicle(lookupId:$lookupId) {objs{\n\t\tlookupId\n\t\tcreatedAt\n\t\tcircle\n\t\tline\n\t\tdrawn\n\t\trectangle\n\t\ttype\n\t\tborderColor\n\t\tcolor\n\t\tuuid\n\t\tname\n\t isActive\n\t}}\n\tgenerateWsToken\n}\n",
    variables: data,
  };
  dt_template.query = vehiclePresubscription.query;
  dt_template.variables = vehiclePresubscription.variables;
  return dt_template;
};
export const vehicleAlertUpdateMessageBypass = (data) => {
  let vehicleAlertUpdateMessageBypass = {
    query:
      "mutation ($alertLookupId: String!) {\n\tvehicleAlertUpdateMessageBypass(alertLookupId: $alertLookupId) {\n\t\talert {\n\t\t\tlookupId\n\t\t\tstatus\n\t\t}\n\t}\n}\n",
    variables: data,
  };
  dt_template.query = vehicleAlertUpdateMessageBypass.query;
  dt_template.variables = vehicleAlertUpdateMessageBypass.variables;
  return dt_template;
};
